export const OPERATIONAL = 'infrastructure'
export const TECHNICAL = 'operational-technical'

export const ALL_DEPARTMENTS = [
  OPERATIONAL,
  TECHNICAL,
] as const

export type Department = typeof ALL_DEPARTMENTS[number]
